// import React from 'react';
// import Navbar from './global-components/navbar';
// import Banner from './section-components/banner';
// import Intro from './section-components/intro-v2';
// import Testimonial from './section-components/testimonial';
// import AboutV4 from './section-components/about-v4';
// import Counter from './section-components/counter';
// import LatestPost from './blog-components/latest-news';
// import Footer from './global-components/footer-v2';
// import CourseHomepage from './section-components/course-homepage';
// import Blog from './blog-components/blog';
// import "react-responsive-carousel/lib/styles/carousel.min.css";

// const Home_V1 = () => {
//     return <div>
//         <Navbar /><br/><br/><br/>
//         <Banner />
//         <CourseHomepage /><br/><br/><br/>
//         <Intro /><br/><br/><br/>
//         <AboutV4 />
//         <Counter />
//         <Testimonial /><br/><br/><br/>
//         <hr className='home-break'/>
//         <LatestPost />
//         <Blog />
//         <Footer />
//     </div>
// }

// export default Home_V1


import React from 'react';
import { Helmet } from 'react-helmet';

import Navbar from './global-components/navbar';
import Banner from './section-components/banner';
import Intro from './section-components/intro-v2';
import Testimonial from './section-components/testimonial';
import AboutV4 from './section-components/about-v4';
import Counter from './section-components/counter';
import LatestPost from './blog-components/latest-news';
import Footer from './global-components/footer-v2';
import CourseHomepage from './section-components/course-homepage';
import Blog from './blog-components/blog';

import "react-responsive-carousel/lib/styles/carousel.min.css";

const Home_V1 = () => {
    return (
        <div>
            <Helmet>
                <title>Best Training & Coaching Institute in Kodambakkam, Chennai | MIET</title>
                <meta 
                    name="description" 
                    content="Best Training & Coaching Institute in Chennai, MIET Education in Kodambakkam offers top NEET, JEE & NATA coaching with expert faculty & proven success rates." 
                />
            </Helmet>
            <Navbar /><br /><br /><br />
            <Banner />
            <CourseHomepage /><br /><br /><br />
            <Intro /><br /><br /><br />
            <AboutV4 />
            <Counter />
            <Testimonial /><br /><br /><br />
            <hr className='home-break' />
            <LatestPost />
            <Blog />
            <Footer />
        </div>
    );
}

export default Home_V1;

